export const filterMedicalOrganizationVaccines = ({
  medicalOrganizationVaccines,
  selectedCategories,
  selectedVaccine,
  tagFilters,
  searchTerm,
}) => (
  medicalOrganizationVaccines
    .filter(medicalOrganization => {
      if (selectedCategories.length === 0) return true;
      return selectedCategories.includes(medicalOrganization.category);
    })
    .filter(medicalOrganization => {
      if (selectedVaccine.length === 0) return true;
      return selectedVaccine.some(v => medicalOrganization.vaccines.includes(v))
    })
    .filter(medicalOrganization =>
      medicalOrganization.name.includes(searchTerm.trim())
      || medicalOrganization.address.includes(searchTerm.trim())
    )
    .filter(medicalOrganization => {
      if (tagFilters.smokingCessation) return medicalOrganization.smokingCessation
      return true
    })
    .filter(medicalOrganization => {
      if (tagFilters.icope) return medicalOrganization.icope
      return true
    })
    .filter(medicalOrganization => {
      if (tagFilters.hpaPrevention) return medicalOrganization.hpaPrevention
      return true
    })
    .filter(medicalOrganization => {
      if (tagFilters.adultHealthScreening) return medicalOrganization.adultHealthScreening
      return true
    })
)